// Function definitions
const index = function (params) {
    return window.axios.get('/api/products', {params});
};

const get = function (id) {
    return window.axios.get(`/api/products/${id}`);
};

const create = function (data) {
    return window.axios.post('/api/products', data);
};

const update = function (data) {
    return window.axios.put(`/api/products/${data.id}`, data);
};

const deleteProduct = function (id) {
    return window.axios.delete(`/api/products/${id}`);
};

const save = function (data) {
    if (data.id) {
        return update(data);
    }
    return create(data);
};

export default {
    index,
    get,
    create,
    update,
    delete: deleteProduct,
    save,
};


// WEBPACK FOOTER //
// ./resources/assets/js/services/ProductsService.js